import { useAuth } from "../contexts/AuthCtx";
import { motion } from "framer-motion";

const StarIcon = () => {
  return (
    <svg className="w-16 h-16 icon-st1" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <rect className="fill-current str-white" width="64" height="64" rx="32" />
      <path className="stroke-current str-black" d="M30 39.313l-4.18 2.197L27 34.628l-5-4.874 6.91-1.004L32 22.49l3.09 6.26L42 29.754l-3 2.924" strokeLinecap="square" strokeWidth="2" fill="none" fillRule="evenodd" />
      <path className="stroke-current str-black" d="M43 42h-9M43 37h-9" strokeLinecap="square" strokeWidth="2" />
    </svg>
  );
}

const DocIcon = () => {
  return (
    <svg className="w-16 h-16 icon-st1" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <circle className="fill-current str-white" cx="32" cy="32" r="32" />
      <path className="stroke-current str-black" strokeWidth="2" strokeLinecap="square" d="M21 23h22v18H21z" fill="none" fillRule="evenodd" />
      <path className="stroke-current str-black" d="M26 28h12M26 32h12M26 36h5" strokeWidth="2" strokeLinecap="square" />
    </svg>
  );
}

const WebIcon = () => {
  return (
    <svg className="w-16 h-16 icon-st1" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <rect className="fill-current str-white" width="64" height="64" rx="32" />
      <g transform="translate(21 21)" strokeLinecap="square" strokeWidth="2" fill="none" fillRule="evenodd">
        <ellipse className="stroke-current str-black" cx="11" cy="11" rx="5.5" ry="11" />
        <path className="stroke-current str-black" d="M11 0v22M0 11h22" />
        <circle className="stroke-current str-black" cx="11" cy="11" r="11" />
      </g>
    </svg>
  );
}


const ProjectIcon = () => {
  return (
    <svg
      fill="#ffffff"
      className="w-16 h-16 icon-st1"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect className="fill-current str-white" width="64" height="64" rx="32" />
      <g transform="scale(2.1) translate(9 9)">
        <path className="stroke-current str-black" d="M6.3,7l3.85,6L14,7Z" />
        <path className="stroke-current str-black" d="M7,1V5h4V1Zm3,3H8V2h2Z" />
        <path className="stroke-current str-black" d="M1,1V5H5V1ZM4,4H2V2H4Z" />
        <path className="stroke-current str-black" d="M1,7v4H5V7Zm3,3H2V8H4Z" />
      </g>
    </svg>
  );
}

const IndustryIcon = () => {
  return (
    <div className="icon-indv">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="30px"
        viewBox="0 -960 960 960"
        width="30px"
        className="fill-current str-black"
      >
        <path d="M159-120v-120h124L181-574q-27-15-44.5-44T119-680q0-50 35-85t85-35q39 0 69.5 22.5T351-720h128v-40q0-17 11.5-28.5T519-800q9 0 17.5 4t14.5 12l68-64q9-9 21.5-11.5T665-856l156 72q12 6 16.5 17.5T837-744q-6 12-17.5 15.5T797-730l-144-66-94 88v56l94 86 144-66q11-5 23-1t17 15q6 12 1 23t-17 17l-156 74q-12 6-24.5 3.5T619-512l-68-64q-6 6-14.5 11t-17.5 5q-17 0-28.5-11.5T479-600v-40H351q-3 8-6.5 15t-9.5 15l200 370h144v120H159Zm80-520q17 0 28.5-11.5T279-680q0-17-11.5-28.5T239-720q-17 0-28.5 11.5T199-680q0 17 11.5 28.5T239-640Zm126 400h78L271-560h-4l98 320Zm78 0Z" />
      </svg>
    </div>
  );
}


const WorldCompetetiveIcon = () => {
  return (
    <div className="icon-indv">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="30px"
        viewBox="0 -960 960 960"
        width="30px"
        className="fill-current str-black"
      >
        <path d="M472-159q-33 0-56.5-24T392-240q0-33 23.5-56.5T472-320l24-23q8-8 18.5-12.5T536-360q23 0 39.5 17t16.5 40v17q0 20 13 33t33 13q15 0 27-9t17-23l12-33q9-24 29-39.5t46-15.5q11-28 17.5-58t6.5-62q0-89-44.5-162.5T632-758v38q0 33-23.5 56.5T552-640h-40v80q0 17-11.5 28.5T472-520h-40v68q0 22-15 37t-37 15q-14 0-25.5-6T336-423l-64-97h-40v40q0 31-21 53t-50 26q26 104 112.5 173T472-159Zm80-241q-17 0-28.5-11.5T512-440q0-17 11.5-28.5T552-480h40q17 0 28.5 11.5T632-440q0 17-11.5 28.5T592-400h-40Zm93-120q-20 0-31.5-15.5T608-570l15-44q4-12 14-19t22-7q20 0 31.5 15.5T696-590l-15 44q-4 12-14 19t-22 7ZM472-80q-83 0-156-31.5T189-197q-54-54-85.5-127T72-480q0-83 31.5-156T189-763q54-54 127-85.5T472-880q83 0 156 31.5T755-763q54 54 85.5 127T872-480q0 83-31.5 156T755-197q-54 54-127 85.5T472-80Z" />
      </svg>
    </div>
  );
}

const TimeIcon = () => {
  return (
    <div className="icon-indv">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="30px"
        viewBox="0 -960 960 960"
        width="30px"
        className="fill-current str-black"
      >
        <path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z" />
      </svg>
    </div>
  );
}


const IdeaIcon = () => {
  return (
    <svg className="w-16 h-16 icon-st1" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <rect className="fill-current str-white" width="64" height="64" rx="32" />
      <g transform="translate(22 21)" strokeLinecap="square" strokeWidth="2" fill="none" fillRule="evenodd">
        <path className="stroke-current str-black" d="M17 22v-6.3a8.97 8.97 0 003-6.569A9.1 9.1 0 0011.262 0 9 9 0 002 9v1l-2 5 2 1v4a2 2 0 002 2h4a5 5 0 005-5v-5" />
        <circle className="stroke-current str-black" cx="13" cy="9" r="3" />
      </g>
    </svg>
  );
}

// Animation variants 
const getBenefitTextVariant = (i) => {
  return {}
  // return { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { duration: 0.5 } } };
}


const BenefitsSection = () => {

  const authCtx = useAuth();

  return (
    <section className="work-section benefits-section blogs-section-brdr">
      <div className="inner">
        <div className="col">
          <h1 className="impact-hdr">Benefits we offer</h1>
          {/* <p>We provides you a range of benefits for working with us.</p> */}
        </div>
        <div className="services-container">
          <div className="service-card small -st">
            <div className="inner">
              <div className="icon">
                <StarIcon />
              </div>
              <div className="label">
                <motion.h2 initial="hidden"
                  variants={getBenefitTextVariant(0)}
                  whileInView={"visible"}>Personal team</motion.h2>
                <p>Once you start a contract with us, we assign a personal team for you which includes a developer itself.</p>
              </div>
            </div>
          </div>
          <div className="service-card small">
            <div className="inner">
              <div className="icon">
                <DocIcon />
              </div>
              <div className="label">
                <motion.h2 initial="hidden"
                  variants={getBenefitTextVariant(0)}
                  whileInView={"visible"}>NDA Signed</motion.h2>
                <p>With the contract, you also get NDA protection, our all engineers are NDA signed so you don't have to worry about it.</p>
              </div>
            </div>
          </div>
          <div className="service-card small">
            <div className="inner">
              <div className="icon">
                <WebIcon />
              </div>
              <div className="label">
                <motion.h2 initial="hidden"
                  variants={getBenefitTextVariant(0)}
                  whileInView={"visible"}>Free Domain</motion.h2>
                <p>You will get a free applicable domain or hosting from us on applicable contract. T&C apply.</p>
              </div>
            </div>
          </div>
          <div className="service-card small">
            <div className="inner">
              <div className="icon">
                <IdeaIcon />
              </div>
              <div className="label">
                <motion.h2 initial="hidden"
                  variants={getBenefitTextVariant(0)}
                  whileInView={"visible"}>Assistance</motion.h2>
                <p>We won't leave you after the contract like others, we will be in contact with you and solving your queries.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="services-container">
          <div className="service-card small -st">
            <div className="inner">
              <div className="icon">
                <ProjectIcon />
              </div>
              <div className="label">
                <motion.h2 initial="hidden"
                  variants={getBenefitTextVariant(0)}
                  whileInView={"visible"}>230+ Projects</motion.h2>
                <p>Our team is highly experienced in wide range of technologies and always updated with latest technologies, which makes them perfect.</p>
              </div>
            </div>
          </div>
          <div className="service-card small">
            <div className="inner">
              <div className="icon">
                <IndustryIcon />
              </div>
              <div className="label">
                <motion.h2 initial="hidden"
                  variants={getBenefitTextVariant(0)}
                  whileInView={"visible"}>Industry standard</motion.h2>
                <p>We write clean, and industry standard code which helps for faster development and makes it editable without worry and helps in aftermath of the app.</p>
              </div>
            </div>
          </div>
          <div className="service-card small">
            <div className="inner">
              <div className="icon">
                <WorldCompetetiveIcon />
              </div>
              <div className="label">
                <motion.h2 initial="hidden"
                  variants={getBenefitTextVariant(0)}
                  whileInView={"visible"}>World competetive</motion.h2>
                <p>We always use latest and efficient technologies to build your product which keeps it's efficient for the long term.</p>
              </div>
            </div>
          </div>
          <div className="service-card small">
            <div className="inner">
              <div className="icon">
                <TimeIcon />
              </div>
              <div className="label">
                <motion.h2 initial="hidden"
                  variants={getBenefitTextVariant(0)}
                  whileInView={"visible"}>Timely completion</motion.h2>
                <p>Our team will ensure you get the delivery of project timely, we work with effective strategy which makes the project completed in given time.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <button onClick={(e) => {
            console.log("XXX")
            authCtx.setGetQuote(true);
            // authCtx.toggleShowStartProjectDialog(true)
          }} className="text-button">START PROJECT {'↗'}</button>
        </div>
      </div>
    </section>
  );
}
export default BenefitsSection;